import { useEffect } from 'react';
import { pulseMetadata } from './pulseMetadata.js';

export default function PulseMetadata({ article }) {
  useEffect(() => {
    const meta = pulseMetadata(article);
    const previousTitle = document.title;
    document.title = meta.title;
    const restore = [];
    const set = (selector, tag, attributes, valueAttribute, value) => {
      let element = document.head.querySelector(selector);
      const existed = Boolean(element);
      if (!element) {
        element = document.createElement(tag);
        Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
        document.head.appendChild(element);
      }
      const previous = element.getAttribute(valueAttribute);
      element.setAttribute(valueAttribute, value);
      restore.push(() => {
        if (!existed) element.remove();
        else if (previous === null) element.removeAttribute(valueAttribute);
        else element.setAttribute(valueAttribute, previous);
      });
    };
    set('link[rel="canonical"]', 'link', { rel: 'canonical' }, 'href', meta.canonical);
    set('meta[name="description"]', 'meta', { name: 'description' }, 'content', meta.description);
    for (const [property, value] of Object.entries({ 'og:title': meta.title, 'og:description': meta.description, 'og:url': meta.canonical, 'og:image': meta.image })) {
      set(`meta[property="${property}"]`, 'meta', { property }, 'content', value);
    }
    return () => { document.title = previousTitle; restore.forEach(reset => reset()); };
  }, [article]);
  return null;
}
